import React from 'react'
import ReactWordcloud from 'react-wordcloud'
import { ChartQuestionOption, respondPercentage } from 'hooks/reports'
import { shade } from 'resources/helpers'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'
import 'tippy.js/themes/light.css'
import { livBriteTheme } from 'app/livbrite/resources/theme'

interface Props {
  options: ChartQuestionOption[]
  totalResponses: number
}

export const WordCloud = ({ options, totalResponses }: Props) => {
  const words = options.reduce((obj: any[], option: ChartQuestionOption, i: number) => {
    obj.push({
      text: option.option_label,
      value: option.selected_by
    })
    return obj
  }, [])

  const generateShades = () => {
    const shades: string[] = []

    Array(5).fill('').map((_, i: number) => {
      shades.push(shade(livBriteTheme.palette.primary.alphaDark, (i / 10)))
      return null
    })

    return shades
  }

  const config: any = {
    colors: generateShades(),
    enableTooltip: true,
    deterministic: false,
    fontFamily: 'impact',
    fontSizes: [16, 60],
    fontStyle: 'normal',
    fontWeight: 'normal',
    padding: 1,
    rotations: 3,
    rotationAngles: [0, 90],
    scale: 'sqrt',
    spiral: 'archimedean',
    transitionDuration: 1000,
    tooltipOptions: {
      allowHTML: true,
      theme: 'light'
    }
  }

  const callbacks = {
    getWordTooltip: (word: any) => {
      const value = word.value
      const percentage = `${respondPercentage(value, totalResponses)}%`
      const label = `${word.text} <br/> <strong>${percentage}, ${value} ${value < 2 ? 'Response' : 'Responses'}</strong>`

      return label
    }
  }

  return (
    <>
      <ReactWordcloud words={words} options={config} callbacks={callbacks} />
    </>
  )
}
